import { translations } from "../content/translations";
import { AuthProvider } from "../providers/AuthProvider";
import { EnvironmentProvider } from "../providers/EnvironmentProvider";
import { LanguageProvider, LanguageUtils } from "../providers/LanguageProvider";
import { ModalProvider } from "../providers/ModalProvider";
import { SessionDataProvider } from "../providers/SessionDataProvider";
import { SessionStateProvider } from "../providers/SessionStateProvider";
import { Trans } from "../providers/TranslationProvider";
import { VLabAPIProvider } from "../providers/VLabAPIProvider";
import { AWSConnectAgentChildProvider } from "./AWSConnectAgentChildProvider";
import { BinahProvider } from "./BinahProvider";
import { LogProvider } from "./LogProvider";
import { MetricsProvider } from "./MetricsProvider";
import { NavigatorProvider } from "./NavigatorProvider";
import { ScannerProvider } from "./ScannerProvider";
import { ThemeProvider } from "./ThemeProvider";

export function GlobalProviders(props: { children: React.ReactNode }) {
	return (
		<EnvironmentProvider>
			<LogProvider>
				<VLabAPIProvider>
					<AuthProvider>
						<LanguageProvider language={LanguageUtils.getUserLanguage()}>
							<Trans.container resources={translations}>
								<ModalProvider>
									<BinahProvider>
										<ThemeProvider>
											<SessionDataProvider>
												<SessionStateProvider>
													<MetricsProvider metricDebugPopupLocation="above-site-footer">
														<AWSConnectAgentChildProvider>
															<ScannerProvider>
																<NavigatorProvider>{props.children} </NavigatorProvider>
															</ScannerProvider>
														</AWSConnectAgentChildProvider>
													</MetricsProvider>
												</SessionStateProvider>
											</SessionDataProvider>
										</ThemeProvider>
									</BinahProvider>
								</ModalProvider>
							</Trans.container>
						</LanguageProvider>
					</AuthProvider>
				</VLabAPIProvider>
			</LogProvider>
		</EnvironmentProvider>
	);
}
